module.exports = __webpack_public_path__ + "static/portfolio1a-f1366bcb3879befc41b7cfee76989a61.jpg";